import React from 'react'

const DevIcon = ({ name = 'react' }) => {
  return <i className={`devicon-${name}-plain`} />
}

export default DevIcon
